import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Reveal-on-scroll for any element with the `.reveal` class.
 * Re-scans the DOM after each route change so newly mounted
 * sections animate in. Mirrors the design-system IntersectionObserver.
 */
export default function ScrollReveal() {
  const location = useLocation();

  useEffect(() => {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-in');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12 }
    );

    // Defer to next frame so freshly routed content is in the DOM.
    const raf = requestAnimationFrame(() => {
      document.querySelectorAll('.reveal:not(.is-in)').forEach((el) => io.observe(el));
    });

    return () => {
      cancelAnimationFrame(raf);
      io.disconnect();
    };
  }, [location.pathname]);

  return null;
}
